import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';

import '@material-design-icons/font/index.css';

import { store } from './app/store';
import { applySlotToTitle } from './app/slot';

import App from './App.tsx'

import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import './index.less'

applySlotToTitle();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <main className="light text-foreground bg-background">
      <Provider store={store.store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </main>
  </StrictMode>,
)
